import React from "react";
import { getBrokerRequest } from "api/broker";
import { getSellersRequest } from "api/seller";
import moment from "moment";
import History from "components/History/History";
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Row,
    Col,
    Nav,
    NavLink,
    NavItem,
    Table
  } from "reactstrap";

class BrokerDetails extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      broker: null,
      sellers: null,
      sellersFilters: null,
      addingEntry: false,
      newEntryText: "",
      saving: false,
      activeTab: "information",
      loading: false
    };
  }

  async componentDidMount() {
    const { sellersFilters } = this.state;

    const params = new URLSearchParams(this.props.location.search);
    const id = params.get("id");

    if (id) {
      const broker = await getBrokerRequest(id);
      this.setState({
        broker,
        sellersFilters: {...sellersFilters, brokerId: broker._id}
      });
    } else {
      this.goTo("/brokers");
    }
  }

  goTo = (path) => this.props.history.push(path);

  changeActiveTab = (e, tabState, tadName) => {
    e.preventDefault();

    if (tadName === "Sellers") this.loadSellers()

    this.setState({
      [tabState]: tadName,
    });
  };



  loadSellers = async () => {
    this.setState({
      loading: true
    })
    try {
      const { sellersFilters } = this.state;
      const sellersObj = await getSellersRequest(sellersFilters);
      const sellers = sellersObj.sellers;
      this.setState({
        sellers
      })
    } catch (err) {
      console.log(err.message)
    } finally {
      this.setState({
        loading: false
      })
    }

  }

  renderActiveTab = (tab) => {
    const {
      loading,
      sellers,
      broker,
    } = this.state;

    switch(tab) {
      case "information":
        return (
          <>
            <Card>
              <CardBody>
                <Row>
                  <Col sm="8">
                    <div className="typography-line">
                        <h4>
                          <span>ID</span>
                          {broker?._id}
                        </h4>
                      </div>                                
                      <div className="typography-line">
                        <h4>
                          <span>Name</span>
                          {broker?.name || "N/A"}
                        </h4>
                      </div>
                      <div className="typography-line">
                        <h4>
                          <span>Phone</span>
                          {broker?.phone || "N/A"}
                        </h4>
                      </div>
                      <div className="typography-line">
                        <h4>
                          <span>Email</span>
                          {broker?.email || "N/A"}
                        </h4>
                      </div>
                      <div className="typography-line">
                        <h4>
                          <span>Date of Birth</span>
                          {broker?.dateOfBirth ? moment(broker.dateOfBirth).format('MM/DD/YYYY') : 'N/A'}
                        </h4>
                      </div>
                      <div className="typography-line">
                        <h4>
                          <span>Company Address</span>
                          {broker?.companyAddress ? 
                              `${broker.companyAddress.street || ''}, 
                               ${broker.companyAddress.city || ''}, 
                               ${broker.companyAddress.state || ''}, 
                               ${broker.companyAddress.country || ''}, 
                               ${broker.companyAddress.zipCode || ''}` 
                              : 'N/A'}
                        </h4>
                      </div>
                      <div className="typography-line">
                        <h4>
                          <span>Is Vatable</span>
                          {broker?.isVatable ? 'Yes' : 'No'}
                        </h4>
                      </div>
                      <div className="typography-line">
                        <h4>
                          <span>PRC Number</span>
                          {broker?.prcNumber || 'N/A'}
                        </h4>
                      </div>
                      <div className="typography-line">
                        <h4>
                          <span>PRC Date</span>
                          {broker?.prcDate ? moment(broker.prcDate).format('MM/DD/YYYY') : 'N/A'}
                        </h4>
                      </div>
                      <div className="typography-line">
                        <h4>
                          <span>PRC Expiration</span>
                          {broker?.pcrExpiration ? moment(broker.pcrExpiration).format('MM/DD/YYYY') : 'N/A'}
                        </h4>
                      </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <History location={this.props.location} component={broker} type={'broker'} />
          </>
        )
      case "sellers":
        return (
          <Table responsive>
            {!loading ? 
            <>
              <thead className="text-primary">
              <tr>
                  <th>Name</th>
                  <th>Age</th>
                  <th>Gender</th>
                  <th>birthday</th>
                  <th>email</th>
                  <th>phone</th>
              </tr>
              </thead>
              <tbody>
                  {sellers && sellers.length > 0 ? 
                      sellers.map((seller) => {
                          return (
                              <tr key={seller._id} onClick={() => this.goTo(`/seller?id=${seller._id}`)}>
                                  <td>{`${seller.first_name} ${seller.last_name}`}</td>
                                  <td>{seller.age || "N/A"}</td>
                                  <td>{seller.gender || "N/A"}</td>
                                  <td>{seller?.birthday
                                      ? moment(seller?.birthday).format(
                                          "MM/DD/YYYY"
                                      )
                                      : "N/A"}
                                  </td>
                                  <td>{seller.email || "N/A"}</td>
                                  <td>{seller.phone || "N/A"}</td>
                              </tr>
                          )
                      })
                  : 
                  <tr>
                      <td colSpan="6">There's no seller to show</td>
                  </tr>
                  }
              </tbody>
            </>
            : <div>Loading...</div>}
          </Table>
        )
      default: return <p>Default case in renderActiveTab</p>
    }
  }

  render() {

    const {
      broker,
      activeTab
    } = this.state;

    const tabs = [
      {
        title: "Information",
        type: "information"
      },
      {
        title: "Sellers",
        type: "sellers"
      },
    ];
      

    return (
        <>
          <div className="content">
            <Row>
              <Col md="12">
                <Card>
                  <CardHeader>
                    <CardTitle tag="h3">
                        Broker Details
                        <Button
                          className="float-right"
                          color="default"
                          onClick={() => this.goTo("/brokers")}
                        >
                          Back
                        </Button>
                        <Button
                          className="float-right mr-2"
                          color="default"
                          onClick={() => this.goTo(`/broker/edit?id=${broker._id}`)}
                        >
                          Edit
                        </Button>
                    </CardTitle>
                    <Nav className="nav-pills-info" pills>
                      {tabs.map((tab) => {
                        return (
                          <NavItem key={tab.title}>
                            <NavLink
                              data-toggle="tab"
                              href="#pablo"
                              className={
                                this.state.activeTab === tab.type
                                  ? "active"
                                  : ""
                              }
                              onClick={(e) =>
                                this.changeActiveTab(
                                  e,
                                  "activeTab",
                                  tab.type
                                )
                              }
                            >
                              {tab.title}
                            </NavLink>
                          </NavItem>
                        )
                      })}
                    </Nav>
                  </CardHeader>
                  <CardBody>
                   {this.renderActiveTab(activeTab)}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </>
    )
  }
}

export default BrokerDetails;